import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: '100%'
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    borderBottom: '1px solid #E2EBF6',
    boxSizing: 'border-box',
    minHeight: '48px',
    padding: '0 30px'
  },
  toolbarTitle: {
    fontWeight: 'bold',
  },
  listWrapper: {
    height: '100%',
    padding: '15px 30px 20px'
  }
});

export default useStyles;
